import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import PeopleIcon from "@material-ui/icons/People";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _ClientsListTable } from "../components";
import { _Select } from "../form";
import useTable from "../hooks/Table";

export const _ClientsList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({ ID_Anag: "", Denominazione: "", CodiceFiscalePartitaIVA: "", ID_TipoAnagStato: "", ID_TipoAnag: "" });
    const { Data, Options, IsLoading } = useTable("/api/Anag/Ricerca", FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("AnagController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={PeopleIcon} Title="Anagrafica">
                    {Glob.AzioneAbilitata("AnagController", Glob.Scrittura) && (
                        <NavLink to="/anagrafica/0">
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <PersonAddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                </_PageTitle>
                <_MainContent>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={6} md={2}>
                                <TextField fullWidth id="ID_Anag" label={Trad.Trad("ID")} value={FormData.ID_Anag} onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })} />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <TextField
                                    fullWidth
                                    id="Denominazione"
                                    label={Trad.Trad("Nome")}
                                    value={FormData.Denominazione}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <TextField
                                    fullWidth
                                    id="CodiceFiscalePartitaIVA"
                                    label={Trad.Trad("PIVACF")}
                                    value={FormData.CodiceFiscalePartitaIVA}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <_Select
                                    Value={FormData.ID_TipoAnagStato}
                                    Name="ID_TipoAnagStato"
                                    Label="TipoAnagStato"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Options={(Data?.Tipi && Data.Tipi["TipiAnagStati"]) || {}}
                                />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <_Select
                                    Value={FormData.ID_TipoAnag}
                                    Name="ID_TipoAnag"
                                    Label="TipoAnag"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Options={(Data?.Tipi && Data.Tipi["TipiAnagPrincipale"]) || {}}
                                />
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid item md={1}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca")}
                                    OnClick={() => {
                                        Options.onChangePage(0);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <_ClientsListTable Data={Data} IsLoading={IsLoading} Options={Options} />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/ClientsList.tsx